import { BernieGraphqlClient, FetchPolicy, RequestOptions } from 'bernie-graphql';
import * as generated from './types';
import * as operations from './operations';

export interface OperationResult<T> {
  data: T;
  errors?: [];
  extensions: any;
  headers: Headers;
}

function isFetchPolicy(requestOptions: RequestOptions | FetchPolicy): requestOptions is FetchPolicy {
  return typeof requestOptions === 'string';
}

export class ApiOperations {
  public constructor(private client: BernieGraphqlClient) {
    //
  }

  public carDetail(
    variables: generated.CarDetail.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.CarDetail.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options){
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query : operations.carDetailQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.CarDetail.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public carDropOffSearch(
    variables: generated.CarDropOffSearch.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.CarDropOffSearch.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options){
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query : operations.carDropOffSearchQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.CarDropOffSearch.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public carSearchV3(
    variables: generated.CarSearchV3.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.CarSearchV3.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options){
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query : operations.carSearchV3Query,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.CarSearchV3.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public static withClient(client: BernieGraphqlClient) {
    return new ApiOperations(client);
  }
}
